import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import * as Sentry from "@sentry/react";

Sentry.init({
  environment: process.env.NODE_ENV || "development",
  dsn: "https://398bc05c6b023e9580408bd002ed644a@o4508434425184256.ingest.de.sentry.io/4509725352788048",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(), // optional: session replay
  ],
  tracesSampleRate: 1.0, // Adjust this in production (e.g., 0.2)
  replaysSessionSampleRate: 0.1, // 10% of sessions recorded
  replaysOnErrorSampleRate: 1.0, // 100% if an error occurs
  beforeSend(event) {
    if (window.location.hostname === "localhost") {
      return null;
    }
    try {
      event.extra = {
        ...event.extra,
        localStorageSnapshot: {
          currentApplicationId: localStorage.getItem("currentApplicationId"),
          currentJobId: localStorage.getItem("currentJobId"),
        },
      };
    } catch (err) {
      // In case localStorage is blocked
      console.warn("Unable to read localStorage", err);
    }
    return event;
  },
});

createRoot(document.getElementById("root")!).render(<App />);
